import { Suspense, lazy, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import ServiceHomepage from "./homepage/login";
import HowToUse from "./howtouse/HowToUse";
import { PresentationProvider } from "../context/PresentationContext";

import { useUser, AuthState } from "../context/UserContext";
import { DataProvider, useData } from "../context/DataContext";

import { Player } from "@lottiefiles/react-lottie-player";
import loadingAnimation from "../assets/loading.json";
import BarrierSummary from "./presentation/barrierslide/summary";
//import { EntityResult } from "../API"; // Import the existing type

//import { Entity } from "../API";
//import DebugEntities from "./DebugEntities";

const LoadingIndicator = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // This makes it take full viewport height
      }}
    >
      <h1>Loading...</h1>
      <Player
        src={loadingAnimation}
        loop
        autoplay
        style={{ height: "200px", width: "200px" }}
      />
    </div>
    // <div
    //   style={{
    //     position: "fixed",
    //     top: 0,
    //     left: 0,
    //     right: 0,
    //     height: "3px",
    //     backgroundColor: "#f0f0f0",
    //   }}
    // >
    //   <div
    //     style={{
    //       width: "30%",
    //       height: "100%",
    //       backgroundColor: "#007bff",
    //       animation: "loading 1s infinite linear",
    //     }}
    //   />
    // </div>
  );
};

// Preload function to start loading components
const preloadRoutes = () => {
  return Promise.all([
    import("./homepage/hub"),
    import("./datatables/barrierstable"),
    import("./datatables/ideastable"),
    import("./datatables/successtoriestable"),
    import("./datatables/safetytable"),
    import("./presentation/storyslide"),
    import("./presentation/storyslide/detail"),
    import("./presentation/safetyslide"),
    import("./presentation/safetyslide/detail"),
    import("./presentation/barrierslide"),
    import("./presentation/barrierslide/detail"),
    import("./presentation/ideaslide"),
    import("./presentation/ideaslide/detail"),
    import("./presentation/thankyou"),
    import("./detail/DetailStory"),
    import("./detail/DetailSafety"),
    import("./detail/DetailBarrier"),
    import("./detail/DetailIdea"),
    import("./addnew/addstory/newStory"),
    import("./addnew/addsafety/newSafety"),
    import("./addnew/addbarrier/newBarrier"),
    import("./addnew/addidea/newIdea"),
    import("./presentation/intro/Intro"),
    import("./presentation/config/Config"),
    import("./presentation/metric"),
    import("./edit/EditStory"),
    import("./edit/EditSafety"),
    import("./edit/EditBarrier"),
    import("./edit/EditIdea"),
    import("./presentation/ideaslide/stats"),
    import("./presentation/barrierslide/summary"),
    import("./report/Report"),
    import("./report/QuickSummary"),
  ]);
};

// Create lazy loaded wrapper for routes
const LazyRoutes = lazy(() => {
  return preloadRoutes().then(
    ([
      HubView,
      BarrierTableView,
      IdeaTableView,
      StoryTableView,
      SafetyTableView,
      StorySlide,
      DetailStorySlide,
      SafetySlide,
      DetailSafetySlide,
      BarrierSlide,
      DetailBarrierSlide,
      IdeaSlide,
      DetailIdeaSlide,
      ThankYouSlide,
      StoryDetails,
      SafetyDetails,
      BarrierDetails,
      IdeaDetails,
      NewStory,
      NewSafety,
      NewBarrier,
      NewIdea,
      IntroPage,
      ConfigPage,
      MetricSlide,
      EditStory,
      EditSafety,
      EditBarrier,
      EditIdea,
      StatsPage,
      BarrierSummary,
      Report,
      QuickSummary,
    ]) => ({
      default: () => (
        <Routes>
          <Route path="/home" element={<HubView.default />} />
          <Route path="/report" element={<Report.default />} />
          <Route path="/quicksummary" element={<QuickSummary.default />} />
          <Route path="/intro" element={<IntroPage.default />} />
          <Route path="/config" element={<ConfigPage.default />} />
          <Route path="/barriertable" element={<BarrierTableView.default />} />
          <Route path="/ideatable" element={<IdeaTableView.default />} />
          <Route path="/storytable" element={<StoryTableView.default />} />
          <Route path="/safetytable" element={<SafetyTableView.default />} />
          <Route path="/storyslide" element={<StorySlide.default />} />
          <Route
            path="/storydetailslide"
            element={<DetailStorySlide.default />}
          />
          <Route path="/safetyslide" element={<SafetySlide.default />} />
          <Route
            path="/safetydetailslide"
            element={<DetailSafetySlide.default />}
          />
          <Route path="/barrierslide" element={<BarrierSlide.default />} />
          <Route
            path="/barrierdetailslide"
            element={<DetailBarrierSlide.default />}
          />
          <Route path="/ideaslide" element={<IdeaSlide.default />} />
          <Route
            path="/ideadetailslide"
            element={<DetailIdeaSlide.default />}
          />
          <Route path="/thankyou" element={<ThankYouSlide.default />} />
          <Route path="/storydetail" element={<StoryDetails.default />} />
          <Route path="/safetydetail" element={<SafetyDetails.default />} />
          <Route path="/barrierdetail" element={<BarrierDetails.default />} />
          <Route path="/ideadetail" element={<IdeaDetails.default />} />
          <Route path="/storyadd" element={<NewStory.default />} />
          <Route path="/safetyadd" element={<NewSafety.default />} />
          <Route path="/barrieradd" element={<NewBarrier.default />} />
          <Route path="/ideaadd" element={<NewIdea.default />} />
          <Route path="/metric" element={<MetricSlide.default />} />
          <Route path="/stats" element={<StatsPage.default />} />
          <Route path="/barriersummary" element={<BarrierSummary.default />} />
          <Route path="/storyedit" element={<EditStory.default />} />
          <Route path="/safetyedit" element={<EditSafety.default />} />
          <Route path="/ideaedit" element={<EditIdea.default />} />
          <Route path="/barrieredit" element={<EditBarrier.default />} />
        </Routes>
      ),
    })
  );
});

export default function App() {
  const { user, authState } = useUser();
  console.log("Auth State:", authState); // Add this to debug auth state
  console.log("User:", user); // Add this to debug user object
  
  // Move useEffect outside of the condition
  useEffect(() => {
    if (authState === AuthState.AUTHORIZED) {
      preloadRoutes();
    }
  }, [authState]);

  if (authState === AuthState.LOADING) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // This makes it take full viewport height
        }}
      >
        <h1>Authorizing...</h1>
        <Player
          src={loadingAnimation}
          loop
          autoplay
          style={{ height: "200px", width: "200px" }}
        />
      </div>
    );
  }

  if (authState == AuthState.AUTHORIZED) {
    //testing graphgl
    // return (
    //   <DataProvider user={user}>
    //     <DebugEntities/>
    //   </DataProvider>
    // );
    //testing graphgl create
    // return (
    //   <DataProvider user={user}>
    //     <DebugCreateEntity />
    //   </DataProvider>
    // );
    //Start preloading immediately when App mounts
    // useEffect(() => {
    //   preloadRoutes();
    // }, []);
    return (
      <DataProvider user={user}>
        <PresentationProvider>
          <Routes>
            {/* ServiceHomepage will load and display immediately */}
            <Route path="/" element={<ServiceHomepage />} />
            {/* Onboarding guide, linked from the sign-in page */}
            <Route path="/how-to-use" element={<HowToUse />} />
            {/* All other routes */}
            <Route
              path="/*"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <LazyRoutes />
                </Suspense>
              }
            />
          </Routes>
        </PresentationProvider>
      </DataProvider>
    );
  }
}
